import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { Modal } from '@isyc-react/design/bootstrap';
import { InputTextarea } from '@isyc-react/form/modules/input/textarea';
import { useTranslation } from 'react-i18next';
import { nsoncustomer } from "../../../../i18n/namespaces";
export const InputParameterEditRemarksModal = props => {
  var _props$remarks;
  const {
    modal,
    setModal,
    onFinish
  } = props;
  const [remarks, setRemarks] = React.useState((_props$remarks = props.remarks) !== null && _props$remarks !== void 0 ? _props$remarks : '');
  const {
    t
  } = useTranslation(nsoncustomer.common);
  return /*#__PURE__*/React.createElement("div", {
    onKeyDown: e => e.stopPropagation(),
    onClick: e => e.stopPropagation(),
    onFocus: e => e.stopPropagation(),
    onMouseOver: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement(Modal, {
    show: modal,
    dialogClassName: "modal-full-height",
    size: "lg",
    centered: true,
    onHide: () => {
      var _props$remarks2;
      setModal(false);
      setRemarks((_props$remarks2 = props.remarks) !== null && _props$remarks2 !== void 0 ? _props$remarks2 : '');
    }
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "bg-primary",
    closeButton: true,
    closeVariant: "white"
  }, /*#__PURE__*/React.createElement(Modal.Title, null, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "modal-title"
  }, t('core.parameter.editComments'))))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(InputTextarea, {
    minRows: 5,
    maxLength: 255 // Max remarks length
    ,
    value: remarks,
    onChange: remarks => setRemarks(remarks),
    style: {
      resize: 'none'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: () => {
      setModal(false);
      onFinish && onFinish(remarks);
      setRemarks('');
    }
  }, t('core.parameter.saveComments'))))));
};